<div class="editable-textarea-container">
  <div
    #editor
    class="editable-textarea"
    contenteditable="true"
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    [class.highlighted]="isHighlighted"
    [attr.disabled]="disabled ? true : null">
  </div>
  <div class="placeholder" *ngIf="textValue === ''">
    {{ placeholderText }}
  </div>
</div>
<div class="count-div">
  <p>{{ numberOfCharacters }} / {{ maxNumberOfCharacters }}</p>
</div>
